"use strict";
module.exports = {
    DEVELOPMENT: "development",
    PRODUCTION: "production",
};
